<div class="p-5">
    <div class="row">
        <div class="col-sm-3 col-md-4"></div>
        <div class="col-sm-6 col-md-4">
            <div class="header-container mb-2">
                <img src="images/sage-black-logo.svg" alt="Sage" width="120px" height="67.505px">
                <span class="customer-portal-text">{{getPortalTranslationKey() | translate}}</span>
            </div>
            @if (isLoading) {
            <mat-spinner diameter="20" class="text-center mx-auto"></mat-spinner>
            }
            @if (submitted) {
            <app-alert-info [title]="'resetPassword.infoTitle' | translate"
                [subtitle]="'resetPassword.infoSubtitle' | translate" [link]="'resetPassword.infoLink' | translate" />

            }

            @if (!submitted) {
            <hr>
            <p class="log-into-your-account">
                {{'resetPassword.resetYourPassword' | translate}}
            </p>
            <p class="reset-help-text mb-2">{{'resetPassword.enterYourEmailAddress' | translate}} </p>
            <form [formGroup]="resetPasswordForm">
                <div>
                    <mat-label>{{'resetPassword.emailAddress' | translate }}</mat-label>
                    <mat-form-field class="w-100" appearance="outline">
                        <input matInput placeholder="" formControlName="email" maxlength="241">
                        @if (emailControl?.touched && emailControl?.errors?.['required']) {
                        <mat-error class="font-sm">{{'resetPassword.emailRequiredField' | translate}}</mat-error>
                        }
                        @if (emailControl?.errors?.['email']) {
                        <mat-error class="font-sm">{{'resetPassword.validEmail' | translate}}</mat-error>
                        }
                        @if (emailControl?.hasError('serverError')) {
                        <mat-error class="font-sm">{{emailControl?.getError('serverError')}}</mat-error>
                        }
                    </mat-form-field>
                    @if (!submitted && useraliaslist.length <= 0) {
                        <ngx-recaptcha2 [siteKey]="siteKey" formControlName="captcha" (success)="handleSuccess($event)"></ngx-recaptcha2>
                        <button type="submit" class="btn btn-success w-100 my-2"
                        [disabled]="!resetPasswordForm.valid || isDisabled"
                        (click)="resetPassword()"><small>{{'resetPassword.next' | translate }}</small></button>
                    <a href="" class="small link-success" (click)="backToLogin()"
                        [routerLink]="['/sign-in']"><small>{{'resetPassword.backToLogin' | translate }}</small></a>
                    }
                </div>
            </form>

            }

            @if (submitted) {
            <button type="submit" class="btn btn-success w-100 mt-3"
                (click)="backToLogin()"><small>{{'resetPassword.backToLogin' | translate }}</small></button>

            }
        </div>
        <div class="col-sm-3 col-md-4"></div>

    </div>
    <div class="row">
        @if (useraliaslist.length > 1 && !submitted) {
        <div class="col-sm-6 col-md-4 mx-auto">
            <p class="bg-warning p-3 rounded font-lg">
                {{'resetPassword.moreThanOneUserIdExists' | translate}}
            </p>
        </div>
        }
        
    </div>
    <div class="row px-5">
        @if(useraliaslist.length > 1 && !submitted) {
        <app-reset-password-userid-table [useraliaslist]="useraliaslist"
            (selectedRow)="onSelectedRow($event)"></app-reset-password-userid-table>
                        <button type="submit" class="btn btn-success my-3 list-btn"
                        [disabled]="!resetPasswordForm.valid || isDisabled"
                        (click)="resetPassword()"><small>{{'resetPassword.next' | translate }}</small>
                    </button>
                    <div class="d-flex justify-content-center">
                        <a href="" class="small link-success" (click)="backToLogin()"
                        [routerLink]="['/sign-in']"><small>{{'resetPassword.backToLogin' | translate }}</small></a>
                    </div>
                    
        }
    </div>
</div>